function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "product",
  transform: "translate(-3 -1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3108",
  "data-name": "Group 3108",
  transform: "translate(14.795 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_346",
  "data-name": "Path 346",
  d: "M18.685,6.9H17V1.843A.842.842,0,0,1,17.843,1H22.9V2.685H18.685Z",
  transform: "translate(-17 -1)",
  fill: "#ac1ede"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3109",
  "data-name": "Group 3109",
  transform: "translate(34.173 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_347",
  "data-name": "Path 347",
  d: "M45.9,6.9H44.213V2.685H40V1h5.055a.842.842,0,0,1,.843.843Z",
  transform: "translate(-40 -1)",
  fill: "#ac1ede"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3110",
  "data-name": "Group 3110",
  transform: "translate(3 4.37)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_348",
  "data-name": "Path 348",
  d: "M39.535,5H30.268V7.528h5.9a.842.842,0,0,1,.843.843V10.9H35.323V9.213H30.268v.843a.842.842,0,0,1-.843.843H26.9V9.213h1.685V5H21V23.535H39.535ZM34.48,14.268v1.685H31.11v3.37H29.425V15.11a.842.842,0,0,1,.843-.843Zm-5.9-2.528h1.685v1.685H28.583Zm-3.37-5.055H26.9V8.37H25.213Zm-2.528,0H24.37V8.37H22.685Zm0,5.9a.842.842,0,0,1,.843-.843h.843V10.9H22.685V9.213h2.528a.842.842,0,0,1,.843.843V11.74H27.74v1.685H24.37V16.8H22.685ZM24.37,21.85H22.685V20.165H24.37Zm2.528,0H25.213V19.323H22.685V17.638h3.37a.842.842,0,0,1,.843.843Zm-1.685-5.9V14.268H26.9v1.685h1.685v1.685H26.9V15.953Zm8.425,5.055a.842.842,0,0,1-.843.843H27.74V20.165h4.213V16.8h1.685Zm4.213,0a.842.842,0,0,1-.843.843H34.48V20.165h1.685V16.8H37.85Zm0-5.9H36.165V13.425H34.48V11.74H32.8v1.685H31.11V11.74H32.8V10.055H34.48V11.74h2.528a.842.842,0,0,1,.843.843Z",
  transform: "translate(-5.835 -5)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_349",
  "data-name": "Path 349",
  d: "M15.832,33.118l-11.6,5.8,11.6,5.8,11.6-5.8Z",
  transform: "translate(-3.195 -9.428)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_350",
  "data-name": "Path 350",
  d: "M3,51.529l11.8,5.9V47.516L3,41.618Z",
  transform: "translate(-3 -10.767)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_351",
  "data-name": "Path 351",
  d: "M44.147,33.118l-9.911,4.956.178.088a.843.843,0,0,1,.466.754v1.164l9.268,4.634,11.6-5.8Z",
  transform: "translate(-7.919 -9.428)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_352",
  "data-name": "Path 352",
  d: "M19,57.427l11.8-5.9V41.618L19,47.516Z",
  transform: "translate(-5.52 -10.767)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_353",
  "data-name": "Path 353",
  d: "M47,47.516v9.911l11.8-5.9V41.618Z",
  transform: "translate(-9.929 -10.767)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_354",
  "data-name": "Path 354",
  d: "M34.88,52.365a.843.843,0,0,1-.466.754l-.178.088L43.3,57.742V47.831L34.88,43.618Z",
  transform: "translate(-7.919 -11.082)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_355",
  "data-name": "Path 355",
  d: "M40,29.9h5.055a.842.842,0,0,0,.843-.843V24H44.213v4.213H40Z",
  transform: "translate(-8.827 -7.992)",
  fill: "#ac1ede"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3111",
  "data-name": "Group 3111",
  transform: "translate(14.795 20.378)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_356",
  "data-name": "Path 356",
  d: "M22.9,29.9H17.843A.842.842,0,0,1,17,29.055V24h1.685v4.213H22.9Z",
  transform: "translate(-17 -24)",
  fill: "#ac1ede"
})));

var SvgProduct = function SvgProduct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.866,
    height: 50.031,
    viewBox: "0 0 48.866 50.031",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProduct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product.a90b822e.svg";
export { ForwardRef as ReactComponent };